/**
 * Wraps each <table> in the given HTML string with a horizontally scrollable <div>.
 * Prevents wide CMS tables from overflowing their container and breaking page layout.
 * Sets dir="ltr" on tables to preserve CMS column order, and dir="rtl" on cells
 * for correct Hebrew text direction. HTML dir attributes bypass stylis-plugin-rtl.
 */
export function wrapTables(html: string): string {
  if (!html) return html
  return html
    .replace(/<table(?=[^>]*>)/gi, (match) => {
      const withoutDir = match.replace(/ dir="[^"]*"/gi, "").replace(/ dir='[^']*'/gi, "")
      return `<div style="overflow-x:auto;max-width:100%">${withoutDir} dir="ltr"`
    })
    .replace(/<\/table>/gi, "</table></div>")
    .replace(/<(td|th)(?=[^>]*>)/gi, (match) => {
      if (/\bdir\s*=/i.test(match)) return match
      return `${match} dir="rtl"`
    })
}
